import { render } from "./AppointmentReport.vue?vue&type=template&id=7d8396af&scoped=true"
import script from "./AppointmentReport.vue?vue&type=script&lang=js"
export * from "./AppointmentReport.vue?vue&type=script&lang=js"

import "./AppointmentReport.vue?vue&type=style&index=0&id=7d8396af&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d8396af"]])

export default __exports__